import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class EngageServicesService {
  private baseUrl: string;
  private api: string = 'api/EngageSC';

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  async engageService_SetupSecurity(encryptedUser: string, engageSCContractID): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/EngageService_SetupSecurity/${engageSCContractID}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "engageSCContractID - " + engageSCContractID, encryptedUser, "EngageServicesService", "engageService_SetupSecurity"); });
    return a;
  }

  async engageServiceSignAgreement(encryptedUser: string, engageSCContractID, franchise, name, title, chkAgree): Promise<any | void> {
    const a = await this.httpClient
      .get<any>(`${this.baseUrl}/EngageServiceSignAgreement/${engageSCContractID}/${franchise}/${name}/${title}/${chkAgree}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "engageSCContractID - " + engageSCContractID + "," + "franchise - " + franchise + "," + "name - " + name + "," + "title - " + title + "," + "chkAgree - " + chkAgree, encryptedUser, "EngageServicesService", "engageServiceSignAgreement"); });
    return a;
  }
}
